export default __webpack_public_path__ + "static/media/skovstykket-tenancy-08.8df98ed6.jpg";